define('LocationShippingTimes.Checkout.EntryPoint', [
  'ZipCodeSession'
], function KodellaLocationShippingTimesCheckout(ZipCodeSession) {
  'use strict';

  return {
    mountToApp: function mountToApp(container) {
      var cart = container.getComponent('Cart');
      var loginRegister = container.getComponent('LoginRegisterPage');

      cart.on('afterSubmit', function onAfterSubmit() {
        ZipCodeSession.clearZipCode();
      });

      loginRegister.on('beforeLogin', function onBeforeLogin() {
        return ZipCodeSession.clearZipCode();
      });
    }
  };
});
